export abstract class AddSubOrgPageContent {
	abstract checkErrors(): boolean | undefined;
}
